// extracted by mini-css-extract-plugin
export var auto = "_3g-1";
export var spinner = "_3g-0";